import React from 'react';
import { View } from 'react-native';

import { Text } from '@/components/ui/text';
import type { ContractWithdrawalFlow } from '../hooks/useContractWithdrawal';
import { profileWebStyles } from '../profileStyles';
import type { Translate } from '../profileTypes';
import { ProfileActionRow } from './ProfileActionRow';

interface ContractWithdrawalCardProps {
  withdrawal: ContractWithdrawalFlow;
  t: Translate;
}

/** EU "Withdraw from contract here" (BIL-L23), shown only inside the withdrawal period. */
export function ContractWithdrawalCard({ withdrawal, t }: ContractWithdrawalCardProps) {
  if (!withdrawal.availableUntil) return null;
  const until = new Date(withdrawal.availableUntil * 1000).toLocaleDateString();

  return (
    <View style={[profileWebStyles.panel, profileWebStyles.panelStacked]}>
      <Text style={profileWebStyles.panelTitle}>{t('profile.withdrawal.panelTitle')}</Text>
      <ProfileActionRow
        title={t('profile.withdrawal.action')}
        subtitle={t('profile.withdrawal.availableUntil', { date: until })}
        icon="assignment-return"
        onPress={withdrawal.openConfirm}
      />
    </View>
  );
}
